import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { CountUp } from 'countup.js';
import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';
import initializeBarChart from '@functions/sorr2025/initialize/initializeBarChart/initializeBarChart';
import initializeSocialChart from '@functions/sorr2025/initialize/initializeSocialChart/initializeSocialChart';
import initializeDeliveryChart from '@functions/sorr2025/initialize/initializeDeliveryChart/initializeDeliveryChart';
import initializeDoughtnutChart from '@functions/sorr2025/initialize/initializeDoughnutChart/initializeDoughtnutChart';
import initializeGroupedBarChart from '@functions/sorr2025/initialize/initializeGroupedBarChart/initializeGroupedBarChart';

const countUpElements = document.querySelectorAll<HTMLElement>('.count-up');
const countUpInstances = [...countUpElements].map((el) => {
    const targetNumber = parseFloat(el.getAttribute('data-count') || '0');
    return new CountUp(el, targetNumber);
});

Chart.register(ChartDataLabels);

(async function () {
    const charts = [];
    const barChart = [...document.querySelectorAll('[id^="bar-chart-"]')];
    const groupedBarChart = [...document.querySelectorAll('[id^="grouped-bar-chart-"]')];

    if (barChart) {
        charts.push(...barChart);
    }

    if (groupedBarChart) {
        charts.push(...groupedBarChart);
    }

    const circleChart = document.getElementById('chart-1') as HTMLCanvasElement;
    if (circleChart) {
        charts.push(circleChart);
    }

    const socialCanvas = document.getElementById('chart-social') as HTMLCanvasElement;
    if (socialCanvas) {
        charts.push(socialCanvas);
    }

    const deliveryCanvas = document.getElementById('chart-delivery') as HTMLCanvasElement;
    if (deliveryCanvas) {
        charts.push(deliveryCanvas);
    }

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const index = ([...countUpElements] as Element[]).indexOf(entry.target);
                    if (index !== -1 && !countUpInstances[index].error) {
                        countUpInstances[index].start();

                        observer.unobserve(entry.target);
                    }
                    if (charts.includes(entry.target)) {
                        const chartId = entry.target.id;
                        if (chartId.includes('bar-chart') && !chartId.includes('grouped')) {
                            initializeBarChart(
                                entry.target as HTMLCanvasElement,
                                (entry.target as HTMLCanvasElement).dataset.id
                            );
                        }
                        if (chartId.includes('grouped-bar-chart')) {
                            initializeGroupedBarChart(
                                entry.target as HTMLCanvasElement,
                                (entry.target as HTMLCanvasElement).dataset.id
                            );
                        }
                        if (chartId === 'chart-social') {
                            initializeSocialChart();
                        }
                        if (chartId === 'chart-delivery') {
                            initializeDeliveryChart();
                        }
                        if (chartId === 'chart-1') {
                            initializeDoughtnutChart();
                        }
                    }
                }
            });
        },
        { threshold: 0.5 }
    );

    countUpElements.forEach((countUp) => observer.observe(countUp));
    charts.forEach((chart) => observer.observe(chart));
})();

new Swiper('#blog_carousel', {
    modules: [Pagination, Navigation],
    slidesPerView: 1,
    loop: true,
    allowTouchMove: true,
    spaceBetween: 20,
    centeredSlides: true,
    navigation: {
        prevEl: '.blog-prev',
        nextEl: '.blog-next',
    },
    pagination: {
        el: '.blog-pagination',
        type: 'bullets',
        clickable: true,
    },
    breakpoints: {
        '768': {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        '992': {
            slidesPerView: 3,
            spaceBetween: 20,
        },
    },
});
